import Axios from "axios";
import { defineStore } from "pinia";
import { getCurrentAuthToken } from "./authToken";

function createAuthorizedClient() {
  const token = getCurrentAuthToken()?.access_token;
  return Axios.create({
    baseURL: "/",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: "Bearer " + token } : {}),
    },
    timeout: 30000,
  });
}

export const useUiStore = defineStore("ui", {
  state: () => ({
    openJobsCount: null,
    globalSnackbarMessage: "",
    globalSnackbar: false,
  }),

  actions: {
    setOpenJobsCount(count) {
      this.openJobsCount = count;
    },

    loadOpenJobsCount() {
      return createAuthorizedClient()
        .get("/api2/customer/jobs/openCount")
        .then((response) => {
          this.setOpenJobsCount(response.data);
        });
    },

    showSnackbar(message) {
      this.globalSnackbarMessage = message;
      this.globalSnackbar = true;
    },

    setSnackbarOpen(isOpen) {
      this.globalSnackbar = isOpen;
    },

    updateSnackbarOpen(isOpen) {
      this.setSnackbarOpen(isOpen);
    },
  },
});